// eslint-disable-next-line
export const autosize = el => {
  if (el) {
    let callback = null;
    switch (el.nodeName) {
      case 'TEXTAREA':
        callback = autoSizeTextArea;
        break;
      default:
        break;
    }
    if (callback) {
      el.addEventListener('keydown', callback);
      autoSizeTextArea(el);
    }
  }
};

const autoSizeTextArea = e => {
  setTimeout(() => {
    const target = e.target ? e.target : e;
    target.style.cssText = 'height:auto;';
    target.style.cssText = `overflow: hidden; height: ${target.scrollHeight}px`;
  }, 0);
};



// WEBPACK FOOTER //
// ./app/util/inputUtils.js